import { getPromoTags } from 'promo-tag-utils';

class LoadMoreButton extends HTMLElement {
  constructor() {
    super();
    this.loadMoreBtn = null;
    this.loadMoreSpinner = null;
    this.productsOnPage = null;
    this.productCountElement = null;
    this.totalProductCountElement = null;
    this.progressBar = null;
    this.initialProductCount = 0;
    this.loadedProductCount = 0;
    this.totalProductCountInt = 0;
    this.collectionName = '';
    this.boundFetchNextPage = this.fetchNextPageProducts.bind(this);
  }

  connectedCallback() {
    this.initElements();
    if (this.loadMoreBtn && this.loadMoreSpinner) {
      this.loadMoreBtn.addEventListener('click', this.boundFetchNextPage);
    }
  }

  disconnectedCallback() {
    if (this.loadMoreBtn) {
      this.loadMoreBtn.removeEventListener('click', this.boundFetchNextPage);
    }
  }

  initElements() {
    this.productsOnPage = document.querySelector('.js-products-on-page');
    this.productCountElement = document.querySelector(
      '.js-product-loaded-count'
    );
    this.totalProductCountElement = document.querySelector(
      '.product-total-count'
    );
    this.totalProductCountInt = parseInt(
      this.totalProductCountElement?.dataset?.totalProducts
    );
    this.initialProductCount = parseInt(
      this.productsOnPage?.dataset?.paginationSize
    );
    this.loadedProductCount = this.initialProductCount;
    this.loadMoreBtn = this.querySelector('.js-load-more-collection__btn');
    this.loadMoreSpinner = this.querySelector('.load-more__spinner');
    this.progressBar = document.querySelector(
      '#search-pagination-progress-bar'
    );
    this.collectionName = this.productsOnPage?.dataset?.collection;
  }

  async fetchNextPageProducts() {
    try {
      this.loadMoreBtn.style.display = 'none';
      this.loadMoreSpinner.style.display = 'block';

      const nextUrl = this.productsOnPage?.dataset?.nextUrl;
      const response = await fetch(nextUrl);
      const next_page = await response.text();

      const parser = new DOMParser();
      const doc = parser.parseFromString(next_page, 'text/html');
      const newProducts = doc.querySelector('.js-products-on-page');

      if (newProducts.dataset.nextUrl) {
        this.loadedProductCount += this.initialProductCount;
      } else {
        this.loadedProductCount = this.totalProductCountInt;
        this.loadMoreBtn.removeEventListener('click', this.boundFetchNextPage);
        dataLayer.push({
          event: 'reached last page of collection',
          vendor: this.collectionName
        });
      }

      this.productCountElement.textContent = this.loadedProductCount;
      this.productsOnPage.dataset.nextUrl = newProducts.dataset.nextUrl;
      const firstNewDetailsHref = newProducts
        .querySelector('.product-card__details')
        ?.getAttribute('href');
      this.productsOnPage.insertAdjacentHTML(
        'beforeend',
        newProducts.innerHTML
      );

      if (firstNewDetailsHref) {
        const allDetailsLinks = this.productsOnPage.querySelectorAll(
          '.product-card__details'
        );
        const focusTarget = Array.from(allDetailsLinks).find(
          el => el.getAttribute('href') === firstNewDetailsHref
        );
        focusTarget?.focus({ preventScroll: false });
      }

      this.loadMoreSpinner.style.display = 'none';

      if (
        window.location.href.includes('collections') ||
        window.location.href.includes('search')
      ) {
        this.progressBar.style.width =
          (this.loadedProductCount / this.totalProductCountInt) * 100 + '%';
      }

      getPromoTags();
      this.toggleLoadMoreBtnDisplay();
    } catch (error) {
      console.error('Error loading more products:', error);
    }
  }

  toggleLoadMoreBtnDisplay() {
    if (this.productsOnPage.dataset.nextUrl) {
      this.loadMoreBtn.style.display = 'block';
    } else {
      this.loadMoreBtn.style.display = 'none';
    }
  }
}

if (!customElements.get('load-more-button')) {
  customElements.define('load-more-button', LoadMoreButton);
}
